import { createReportEditStore } from '@/stores/report-edit/create-report-edit-store';

export type { LocalEdit, NewItem } from '@/stores/report-edit/create-report-edit-store';

interface RecallExtras {
  activeCounterparty: string;
  setActiveCounterparty: (counterparty: string) => void;
}

export const useRecallReportStore = createReportEditStore<RecallExtras>({
  name: 'recall-report-store',
  extraSlice: (set) => ({
    activeCounterparty: 'velocity',
    setActiveCounterparty: (counterparty) => set({ activeCounterparty: counterparty }),
  }),
});
